import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService, MODULE_PATHS } from '../../global/language.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-not-found',
    standalone: true,
    imports: [CommonModule, RouterModule, TranslateModule],
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
    private readonly onDestory$ = new Subject<void>();

    constructor(
        private languageService: LanguageService
    ) {
        this.languageService.loadTranslations(MODULE_PATHS.NOT_FOUND)
            .pipe(takeUntil(this.onDestory$))
            .subscribe();
    }
}